import { render, staticRenderFns } from "./glodenRateInfo.vue?vue&type=template&id=a51f1dac&scoped=true"
import script from "./glodenRateInfo.vue?vue&type=script&lang=js"
export * from "./glodenRateInfo.vue?vue&type=script&lang=js"
import style0 from "./glodenRateInfo.vue?vue&type=style&index=0&id=a51f1dac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51f1dac",
  null
  
)

export default component.exports